module.exports = __webpack_public_path__ + "0a84baae8c9e7375f7d8601d2c72afbc.png";